import React, { Component } from 'react';
import { toast } from 'react-toastify';
import * as api from '../../CustomerSupportBotPage/api';
import { matchesSupportConversation } from '../supportBot';

export default class SupportConversationBot extends Component {
    state = { detail: null, loading: true, error: '', busy: false };
    requestId = 0;
    active = false;

    componentDidMount() {
        this.active = true;
        this.load();
        this.refreshTimer = setInterval(() => {
            if (!this.state.busy && !this.state.loading) this.load(true);
        }, 30000);
    }

    componentWillUnmount() {
        this.active = false;
        this.requestId += 1;
        clearInterval(this.refreshTimer);
    }

    load = (quiet = false) => {
        if (!this.active || this.state.busy) return;
        const requestId = ++this.requestId;
        if (!quiet) this.setState({ loading: true, error: '' });
        api.getConversation(this.props.userId)
            .then(detail => {
                if (!this.active || requestId !== this.requestId) return;
                this.setState({
                    detail: matchesSupportConversation(detail, this.props.account, this.props.userId) ? detail : null,
                    loading: false,
                    error: '',
                });
            })
            .catch(error => {
                if (!this.active || requestId !== this.requestId) return;
                const message = error.response && error.response.data && error.response.data.message;
                const missing = message === 'Hội thoại không tồn tại';
                this.setState({
                    detail: null,
                    loading: false,
                    error: missing ? '' : 'Không tải được trạng thái chatbot. Bạn vẫn có thể chat bình thường.',
                });
            });
    };

    handleAction = async (action) => {
        const { detail, busy, loading, error } = this.state;
        const { account, userId, onResolved } = this.props;
        if (busy || loading || error || !matchesSupportConversation(detail, account, userId)) return;
        const enabled = detail.customerSupportBotEnableReply !== false;
        const question = action === 'resolve'
            ? `Đánh dấu đã xử lý xong hội thoại với ${detail.userName || userId} trên ${account.label}?`
            : `${enabled ? 'Tắt' : 'Bật lại'} BOT cho hội thoại với ${detail.userName || userId} trên ${account.label}?`;
        if (!window.confirm(question)) return;

        this.requestId += 1;
        this.setState({ busy: true });
        try {
            // Backend cập nhật theo userId, nên đọc lại để tránh dùng bản ghi cũ
            // đã chuyển sang phòng chat/app khác trong thời gian nhân viên đang xem.
            const latest = await api.getConversation(userId);
            if (!this.active) return;
            if (!matchesSupportConversation(latest, account, userId)) {
                this.setState({ detail: null });
                toast.error('Bản ghi chatbot không còn khớp hội thoại đang mở. Hãy làm mới.');
                return;
            }
            if (action === 'resolve') {
                await api.resolveConversation(userId);
            } else {
                if ((latest.customerSupportBotEnableReply !== false) !== enabled) {
                    this.setState({ detail: latest });
                    toast.info('Trạng thái BOT vừa thay đổi. Vui lòng kiểm tra lại trước khi thao tác.');
                    return;
                }
                await api.toggleConversationBotReply(userId, !enabled);
            }
            if (!this.active) return;
            toast.success(action === 'resolve' ? 'Đã đánh dấu xử lý xong.' : enabled ? 'Đã tắt BOT tại hội thoại này.' : 'Đã bật lại BOT tại hội thoại này.');
            if (action === 'resolve') onResolved();
        } catch (actionError) {
            if (this.active) toast.error('Không cập nhật được hội thoại. Vui lòng thử lại.');
        } finally {
            if (this.active) this.setState({ busy: false }, () => this.load());
        }
    };

    render() {
        const { detail, loading, error, busy } = this.state;
        const { account } = this.props;
        const enabled = detail && detail.customerSupportBotEnableReply !== false;
        const resolved = detail && detail.status === 'RESOLVED';
        return (
            <div className="support-bot-controls" aria-label={`Chatbot CSKH ${account.label}`}>
                {loading ? <span className="support-bot-state" role="status">BOT: Đang tải…</span> : error ? (
                    <button type="button" className="btn btn-sm btn-outline-secondary" title={`${error} Bấm để thử lại.`} onClick={() => this.load()}>
                        BOT: Lỗi tải <i className="fa fa-refresh" aria-hidden="true" />
                    </button>
                ) : !detail ? (
                    <span className="support-bot-state" title={`Chưa có bản ghi chatbot cho hội thoại này trên ${account.label}.`}>BOT: Chưa có dữ liệu</span>
                ) : (
                    <>
                        <span className={`support-bot-state ${enabled ? 'is-on' : 'is-off'}`} aria-live="polite">BOT: <b>{enabled ? 'Bật' : 'Tắt'}</b></span>
                        <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.handleAction('toggle')} disabled={busy}>
                            {busy && <i className="fa fa-spinner fa-spin mr-1" aria-hidden="true" />}
                            {enabled ? 'Tắt BOT' : 'Bật BOT'}
                        </button>
                        <button type="button" className="btn btn-sm btn-success" onClick={() => this.handleAction('resolve')} disabled={busy || resolved}>
                            {resolved ? 'Đã xử lý' : 'Đánh dấu xử lý'}
                        </button>
                    </>
                )}
            </div>
        );
    }
}
